(function () {
    angular.module('components.customForm', ['utility'])
        .directive('customForm', customForm);

    customForm.$inject = ['customFormService'];
    function customForm(customFormService) {
        var directive = {
            scope: {
                formUrl: '@',
                usePlaceholder: '=?'
            },
            restrict: 'E',
            templateUrl: '/angular/components/customForm/customForm.html',
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            customFormService.getForm(scope.formUrl)
                .then(function (response) {
                    console.log(response);
                    scope.form = response.data;
                })
                .catch(function (data) {

                });
        }
    }
})();